import React from "react";
import { Box, Typography, useTheme, Fade } from "@mui/material";
import { alpha } from "@mui/material/styles";
import zaplogo from "../../img/zaplogo_square.png";

const Busy = () => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        minHeight: "100vh",
        zIndex: 9999,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        background: alpha(theme.palette.primary.main, 0.08),
        overflow: "hidden",
      }}
    >
      {/* Animated background effect */}
      <Box
        sx={{
          position: "absolute",
          width: { xs: "300px", sm: "400px", md: "500px" },
          height: { xs: "300px", sm: "400px", md: "500px" },
          background: `radial-gradient(circle, ${theme.palette.primary.main}15 0%, transparent 70%)`,
          borderRadius: "50%",
          animation: "pulse 3s ease-in-out infinite",
          "@keyframes pulse": {
            "0%, 100%": {
              transform: "scale(1)",
              opacity: 0.5,
            },
            "50%": {
              transform: "scale(1.1)",
              opacity: 0.3,
            },
          },
        }}
      />

      {/* Logo container */}
      <Fade in timeout={800}>
        <Box
          sx={{
            position: "relative",
            zIndex: 1,
            mb: { xs: 3, sm: 4, md: 5 },
          }}
        >
          <Box
            sx={{
              width: { xs: 80, sm: 100, md: 120, lg: 140 },
              height: { xs: 80, sm: 100, md: 120, lg: 140 },
              background: "rgba(255, 255, 255, 0.8)",
              backdropFilter: "blur(10px)",
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              border: `2px solid ${theme.palette.primary.main}30`,
              boxShadow: `0 8px 32px ${theme.palette.primary.main}20`,
              animation: "bounce 1.5s ease-in-out infinite",
              "@keyframes bounce": {
                "0%, 100%": {
                  transform: "translateY(0)",
                },
                "50%": {
                  transform: "translateY(-10px)",
                },
              },
            }}
          >
            <Box
              component="img"
              src={zaplogo}
              alt="Moxy Driving School Logo"
              sx={{
                width: "72%",
                height: "72%",
                borderRadius: "50%",
                objectFit: "contain",
              }}
            />
          </Box>
        </Box>
      </Fade>

      {/* Loading text */}
      <Fade in timeout={1000}>
        <Typography
          variant="h6"
          sx={{
            position: "relative",
            zIndex: 1,
            color: theme.palette.primary.main,
            fontWeight: 500,
            fontSize: { xs: "1rem", sm: "1.15rem", md: "1.25rem" },
            letterSpacing: "0.05em",
            textAlign: "center",
            px: 2,
          }}
        >
          Loading...
        </Typography>
      </Fade>
    </Box>
  );
};

export default Busy;
